/**
 * @desc 解锁WMS锁定库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.unlockStock.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/unlockStock`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
